module.exports = __webpack_public_path__ + "img/calendar2_g.9607361b.svg";